<template>
  <div class="shared-hotel-record-list">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">

      <van-list v-model="loading" :finished="finished" :finished-text="finishedText" @load="onLoad">
        <div class="list-item" v-for="(item, i) in list" :key="i">
          <div class="title">
            <span class="left">{{item.is_admin==0?item.shop_name:'平台操作增加'}}</span>
            <span class="date">{{item.created_at}}</span>
          </div>
          <div class="phone">
            <span class="left">{{item.is_admin==0?`手机号：${item.member_mobile}`:''}}</span>
            <span class="price" v-if="item.type == 1">{{`+${parseFloat(item.order_amount).toFixed(2)}`}}</span>
            <!-- <span class="price" v-if="item.type == 2">{{`-${parseFloat(item.order_amount).toFixed(2)}`}}</span> -->
          </div>
          <div class="remark" v-if="item.is_admin!=0">备注：{{item.comment}}</div>
          <div class="order" v-if="item.is_admin==0">{{`订单号：${item.order_sn}`}}</div>
          <div class="recharge-amount" v-if="item.is_admin==0">充值金额：{{parseFloat(item.actual_amount).toFixed(2)}}</div>
          <div class="give-amount" v-if="item.present_amount != 0&&item.is_admin==0" :style="active_style">赠送金额：{{parseFloat(item.present_amount).toFixed(2)}}</div>
          <div class="coin" v-if="item.deduct_credit_amount&&item.is_admin==0">红包抵扣： {{parseFloat(item.deduct_credit_amount).toFixed(2)}}</div>
        </div>

      </van-list>

      <div class="empty" v-if="list.length === 0">
        <img src="../../../assets/shared-hotel/empty.png" alt="">
        <p>无记录</p>
        <p>暂无充值记录</p>
      </div>

    </van-pull-refresh>
    
  </div>
</template>

<script>
export default {
  name: "recordList",
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 0,
      pageSize:10,
      // 充值记录接口需要type为1
      recordType: 1,
      active_style: {
        'margin-top': '12px',
      }
    };
  },
  created() {},
  mounted() {
    document.querySelectorAll('.van-pull-refresh__track').forEach(item => {
      item.style['min-height'] = document.body.clientHeight - (88 + 70) + 'px'
    })
  },
  computed: {
    finishedText(){
      if (this.list.length && ! this.loading && ! this.refreshing) {
        return '- 没有更多了 -'
      }
      return ''
    },
  },
  methods: {
    onLoad() {
      this.getRecordList();
    },
    onRefresh() {
      this.page = 0;
      this.onLoad();
    },
    getRecordList() {
      this.page ++
      let params = {
        type: this.recordType,
        page: this.page,
        pageSize:this.pageSize,
      }
      
      // if (this.recordType == 1) {
      //   this.refreshing = false
      //   this.loading = false
      //   this.list.push(...[1,1,1,1,1])
      // }
      // if (this.recordType == 2) {
      //   if (this.refreshing) {
      //     this.list = [1,1,1]
      //   }
      //   this.finished = true
      //   this.refreshing = false
      //   this.loading = false
      // }

      this.$api.post("/offshop/member/canteen/membership-card/record", params).then((res) => {
        let _list = res.list
        if (this.refreshing) {
          this.list = [];
          this.finished = false;
        }

        this.list.push(..._list)

        if (this.list.length === 0 || _list.length === 0) {
          this.finished = true;
          this.loading = false;
          this.refreshing = false;
          return;
        }

        this.loading = false;

        if (res.current_page == res.last_page) {// 数据全部加载完成
          this.finished = true;
        }

        if (this.refreshing) {
          this.$toast("刷新成功");
          this.refreshing = false;
        }

        if (! this.finished && ! this.loading && this.list.length <= 4) {
          this.onLoad()
        }
        
      })
      .catch(()=>{
        this.loading = false;
        this.refreshing = false;
        this.finished = true
      })
    },

  },
};
</script>

<style lang="less">
.shared-hotel-record-list {
  .list-item {
    width: 100%;
    padding: 10px 12px;
    box-sizing: border-box;
    background-color: #fff;
    border-bottom: 1px solid #F1F1F1;
    .title {
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
      span {
        font-size: 14px;
        color: #2C2C2F;
        line-height: 20px;
      }
      .left {
        flex: 1;
        font-size: 14px;
        font-weight: 600;
      }
      // .date {
      //   width: 133px;
      // }
    }
    .phone {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      .left {
        font-size: 12px;
        color: #666666;
        line-height: 17px;
      }
      .price {
        font-size: 18px;
        font-weight: 600;
        color: #F9591B;
        line-height: 25px;
      }
    }
    .order {
      font-size: 12px;
      color: #666666;
      line-height: 17px;
      margin-bottom: 12px;
    }
    .recharge-amount {
      font-size: 12px;
      color: #666666;
      line-height: 17px;
    }

    .give-amount {
      font-size: 12px;
      color: #666666;
      line-height: 17px;
    }
    .coin {
      font-size: 12px;
      color: #666666;
      line-height: 17px;
      margin-top: 10px;
    }
    .remark{
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        padding: 10px;
        box-sizing: border-box;
        background: #F5F6F7;
        border-radius: 2px;
    }
  }


  .empty {
    width: 100%;
    img {
      width: 100%;
      padding: 161px 47px 50px;
      box-sizing: border-box;
    }
    p:nth-of-type(1) {
      width: 100%;
      text-align: center;
      font-size: 13px;
      color: #333333;
      line-height: 18px;
    }
    p:nth-of-type(2) {
      width: 100%;
      text-align: center;
      font-size: 22px;
      color: #666666;
      line-height: 32px;
      transform: scale(0.5);
    }
  }

  .van-list__finished-text {
    padding-top: 10px;
    font-size: 20px;
    color: #999999;
    line-height: 28px;
    transform: scale(0.5);
  }

}
</style>
